export default __webpack_public_path__ + "static/media/AF_WERFEN_BN_POS_RGB.ac46be62.png";